var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.customerTypeItems,"value":_vm.value,"label":"Kundetype","hide-details":""},on:{"input":_vm.syncValue}})}
var staticRenderFns = []

export { render, staticRenderFns }